// contactsApi.ts
import { APINodeClient } from './apiNodeCore';
import * as nodeUrl from './nodeUrls';

const api = new APINodeClient();

// Fetch contacts from the backend
export const fetchContactsApi = async (recommendation:boolean) => {
  return api.create(`${nodeUrl.GET_CONTACTS}`,{recommendation});
};

// Update contact type
export const updateContactTypeApi = async (id: string, contact_type: string) => {
  return api.create(`${nodeUrl.UPDATE_CONTACT_TYPE}`, { id, contact_type });
};

// Set follow-up configuration
export const setFollowUpConfigApi = async (config: any) => {
  return api.create(nodeUrl.SET_FOLLOWUP_CONFIG, config);
};

// Get follow-up configuration
export const getFollowUpConfigApi = async () => {
  return api.create(nodeUrl.GET_FOLLOWUP_CONFIG);
};

export const getFollowupScheduleApi = async () => {
  return api.get(nodeUrl.GET_FOLLOWUP_SCHEDULE);
};


export const updateTrackAbilityApi = async (id: string, trackable:boolean) => {
  return api.create(`${nodeUrl.UPDATE_CONTACT_TRACK_ABILITY}`, { id , trackable});
};


export const fetchThreadEmailsActionsApi = async (action_id: number) => {
  return api.create(nodeUrl.GET_TRACKABLE_EMAIL_ACTIONS, { action_id });
};


export const getActionByUserIdAndActionIdApi = async (action_id: number) => {
  return api.create(nodeUrl.GET_ACTION_BY_USER_ID_AND_ACTION_ID, { action_id });
};

export const updateContactsFollowupMailSettingsApi = async (payload: any) => {
  return api.create('contacts/update-contact-frequency', payload);
};